<template>
  <Modal show>
      <div class="text-c" v-if="loading">
        <AppLoader />
      </div>
      <div v-else>
        <h2>Leder du efter en rute?</h2>
        <p>Vi er flyttet til en ny platform med nye lækre funktioner. Ruten du forsøger at tilgå er stadig intakt. Flyt ruten til det nye Tripply og få adgang til bl.a. <b>live ruter</b>, så forældre, venner eller kollegaer kan følge ruten og se forventede tider i realtid. <br>Hvis du ejer denne rute så <a href="https://old.tripply.dk/upgrade">læs her hvordan du flytter den</a>. Det tager kun få sekunder!</p>
      </div>
      <template v-if="!loading" v-slot:footer>
        <a :href="'https://old.tripply.dk/' + $route.params.id"><AppButton color="primary">Jeg ville egentlig bare se ruten</AppButton></a>
      </template>
  </Modal>
</template>

<script lang="ts">
import { GA } from '@/api/analytics'
import { db } from '@/api/firebase'
import router from '@/router'
import { defineComponent, computed, PropType, reactive, ref, onMounted } from 'vue'

export default defineComponent({
  name: 'MigrationRoute',
  setup() {
    const loading = ref(true)

    onMounted(async () => {
      const oldRouteId = router.currentRoute.value.params.id as string
      const route = await db.collection('routes').where('migrationId', '==', oldRouteId).limit(1).get()
      if (route.docs.length && route.docs[0].exists) {
        router.push('/r/' + route.docs[0].id)
        GA('migration', { status: 'redirect' })
      } else {
        loading.value = false
        GA('migration', { status: 'modal' })
      }
    })

    return { loading }
  }
})
</script>